import { render, staticRenderFns } from "./trade-footer.vue?vue&type=template&id=d63741d6&scoped=true&"
var script = {}
import style0 from "./trade-footer.vue?vue&type=style&index=0&id=d63741d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63741d6",
  null
  
)

export default component.exports